import React, { Component } from 'react';
import Select from "react-select";
import Swal from "sweetalert2/dist/sweetalert2.js";

const OPERATIONS = [
    { value: '', label: '(usar operacion global)' },
    { value: 'suma', label: 'Suma' },
    { value: 'promedio', label: 'Promedio' },
    { value: 'maximo', label: 'Maximo' },
    { value: 'minimo', label: 'Minimo' },
    { value: 'contador', label: 'Contador' },
    { value: 'valor', label: 'Valor' },
    { value: 'ultimo', label: 'Ultimo' },
    { value: 'primero', label: 'Primero' },
];

class FormCreateMapping extends Component {
    constructor(props) {
        super(props);
        this.token = document.querySelector("[name='csrf-token']").content;

        const m = props.modeEdit && props.mapping ? props.mapping : null;
        this.state = {
            selectedSource: m && m.question_source_info
                ? { label: m.question_source_info.name, value: m.question_source_info.id }
                : null,
            selectedTarget: m && m.question_target_info
                ? { label: m.question_target_info.name, value: m.question_target_info.id }
                : null,
            selectedOperation: m && m.operation
                ? OPERATIONS.find(op => op.value === m.operation) || null
                : null,
        };
    }

    handleSave = () => {
        const { selectedSource, selectedTarget, selectedOperation } = this.state;
        if (!selectedSource || !selectedTarget) return;

        const body = {
            format_search_v2_id: this.props.format_search_v2.id,
            question_source_id: selectedSource.value,
            question_target_id: selectedTarget.value,
            operation: selectedOperation ? selectedOperation.value : "",
        };

        const url = this.props.modeEdit
            ? `/formatos/format_search_v2_mappings/${this.props.mapping.id}`
            : `/formatos/format_search_v2_mappings`;
        const method = this.props.modeEdit ? 'PATCH' : 'POST';

        fetch(url, {
            method,
            body: JSON.stringify(body),
            headers: { "X-CSRF-Token": this.token, "Content-Type": "application/json" }
        })
            .then(r => r.json())
            .then(data => {
                Swal.fire({ position: "center", type: data.type, title: data.success, showConfirmButton: false, timer: 1200 });
                if (this.props.modeEdit && this.props.onUpdated) this.props.onUpdated(data.register);
                else if (this.props.onCreated) this.props.onCreated(data.register);
                this.props.onClose && this.props.onClose();
            });
    }

    render() {
        const isAggregate = this.props.format_search_v2 && this.props.format_search_v2.match_mode === 'aggregate';

        return (
            <div style={{ border: '1px solid #d5d5d5', padding: 12, marginBottom: 12, borderRadius: 4, background: '#fff' }}>
                <div style={{ display: 'flex', gap: 12, marginBottom: 10 }}>
                    <div style={{ flex: 1 }}>
                        <label style={{ fontWeight: 600, fontSize: 12, marginBottom: 4, display: 'block' }}>Pregunta Fuente</label>
                        <Select
                            options={this.props.sourceQuestions || []}
                            value={this.state.selectedSource}
                            onChange={(opt) => this.setState({ selectedSource: opt })}
                            placeholder="Pregunta"
                            className="link-form"
                            isClearable
                        />
                    </div>
                    <div style={{ flex: 1 }}>
                        <label style={{ fontWeight: 600, fontSize: 12, marginBottom: 4, display: 'block' }}>Pregunta Objetivo</label>
                        <Select
                            options={this.props.targetQuestions || []}
                            value={this.state.selectedTarget}
                            onChange={(opt) => this.setState({ selectedTarget: opt })}
                            placeholder="Pregunta"
                            className="link-form"
                            isClearable
                        />
                    </div>
                </div>

                {isAggregate && (
                    <div style={{ marginBottom: 10 }}>
                        <label style={{ fontWeight: 600, fontSize: 12, marginBottom: 4, display: 'block' }}>Operacion (override)</label>
                        <Select
                            options={OPERATIONS}
                            value={this.state.selectedOperation}
                            onChange={(opt) => this.setState({ selectedOperation: opt })}
                            placeholder="Heredar operacion global"
                            className="link-form"
                            isClearable
                        />
                    </div>
                )}

                <div style={{ display: 'flex', gap: 8 }}>
                    <button className="btn btn-info btn-sm" onClick={this.handleSave} disabled={!this.state.selectedSource || !this.state.selectedTarget}>
                        Guardar
                    </button>
                    <button className="btn btn-outline-danger btn-sm" onClick={this.props.onClose}>
                        Cancelar
                    </button>
                </div>
            </div>
        );
    }
}

export default FormCreateMapping;
